import React, {useEffect, useState} from "react";
import dynamic from 'next/dynamic'
import {
    convertNumber,
    getColor,
    getBahabinText,
    getSignWithPercent,
    getTodayJalaliDate
} from "../../../util/DominantUtil";
import {Helmet} from "react-helmet";
import {useIranMetalsGlobalState} from "../../../components/store/IranMetalGlobalState";
import {useIranCurrenciesGlobalState} from "../../../components/store/IranCurrenciesGlobalState";
import {goToTopOfPage} from "../../../util/NavigationUtil";

const BoxDynamicComponent = dynamic(() => import('../../../components/box/Box'))

const TableVirtualizedDynamicComponent = dynamic(() => import('../../../components/virtualized/virtualized'))
export default function Watchlist() {
    const [iranMetalsList, refreshIranMetalsList] = useIranMetalsGlobalState(state => [state.iranMetalsList, state.refreshIranMetalsList]);
    const [autoScrollIntervalId] = useState(null);
    const [tableBgColor, setTableBgColor] = useState('bg-white');
    const scrollToIndex = null

    useEffect(() => {
        refreshIranMetalsList();
    }, [])


    function cleanUpAutoScrollIndex() {
        clearInterval(autoScrollIntervalId);
        // dispatch(watchListSlice.actions.resetIndex())
    }

    function handleSwitchAutoScroll(value) {
        if (autoScrollIntervalId === null && value != null && data && data.length > 10) {
            const id = setInterval(() => {
                // dispatch(watchListSlice.actions.updateIndex({counter: scrollToIndex + 1, length: data.length}));
            }, 2000);
            // dispatch(watchListSlice.actions.setAutoScrollIntervalId({autoScrollIntervalId: id}))
        }

        if (value === false) cleanUpAutoScrollIndex()
    }

    function handleSwitchDark(value) {
        return setTableBgColor(value ? 'bg-dark' : 'bg-white')
    }

    const properties = {
        dropDownInputPlace: 'گروه',
        dropDownIconClassName: 'fa-industry',
        checkedDark: false,
        switchDarkBackground: true,
        handleSwitchDark: handleSwitchDark,
        lastUpdate: iranMetalsList && iranMetalsList.lastUpdate,
        help: {
            title: 'دیده بان بازار',
            content: `      امکانات:
            نمایش تابلو معاملات

            حجم به مبنا:
            حجم معاملات چند برابر حجم مبنا بوده است.
            `
        }
    };

    const tooltipSteps = [
        {
            target: '.extraDarkTheme',
            content: 'تغییر رنگ پس زمینه به سیاه',
            placement: 'right',
        },
        {
            target: '.extraAutoScroll',
            content: 'پیمایش صفحه به صورت خودکار',
        },
        {
            target: '.extra-last-update',
            content: 'زمان دقیق به روز رسانی',
        },
    ]

    const description = `با استفاده از بهابین قیمت بازار طلا و سکه را مشاهده کنید`
    const title = `قیمت لحظه ای طلا و سکه`

    return (
        <BoxDynamicComponent uiActions={properties} loaded={properties.lastUpdate && iranMetalsList}
                             heading={`نرخ و نوسانات بازار طلا و سکه ${getTodayJalaliDate()}`}
                             linksMap={{
                                 'last': 'بازار طلا',
                             }}
                             height='880px'
                             leftBoxClassName={'w-100'}
                             tooltipSteps={tooltipSteps}>
            <Helmet
                title={'قیمت امروز خرید و فروش طلا و سکه' + getBahabinText()}
                meta={[{name: 'description', content: description}, {
                    property: 'twitter:description',
                    content: description
                }, {property: 'og:title', content: title}]}
            />
            <TableVirtualizedDynamicComponent
                market="gold"
                columns={sourceColumn}
                customHeight={830}
                mutableData={iranMetalsList?.data}
                defaultSortBy={'ord'}
                defaultSortDirection={'ASC'}
                keyField="s"
                numberFormat={true}
                scrollToIndex={scrollToIndex}
                setBgClassName={(x) => tableBgColor}
            />
        </BoxDynamicComponent>
    );
};

const sourceColumn = [
    {
        title: "نام",
        dataIndex: "s",
        type: 'link',
        sorter: true,
        enable: true,
    },
    {
        title: "قیمت",
        dataIndex: "c",
        sorter: true,
        enable: true,
    },
    {
        title: "تغییر",
        dataIndex: "P",
        suffix: '%',
        renderer: lastChangeRenderer,
        colorRenderer: getColor,
        sorter: true,
        enable: true,
    },
    {
        title: "کمترین",
        dataIndex: "l",
        sorter: true,
        enable: true,
        disableOnMobile: true,
    },
    {
        title: "بیشترین",
        dataIndex: "h",
        sorter: true,
        enable: true,
        disableOnMobile: true,
    }
]

function lastChangeRenderer(v) {
    return getSignWithPercent(v, 2)
}

function bigNumberFormat(v) {
    return convertNumber(v, 0)
}